import { useTranslation } from "react-i18next";

import Autocomplete from "components/DesignComponents/Autocomplete";
import { DROPDOWN_SIZES, useUserAccessLevels } from "shared";

import { AccessLevelProps } from "./types";

const AccessLevel = ({
    isLoading,
    onChange,
    accessLevel,
    disableClearable
}: AccessLevelProps) => {
    const { t } = useTranslation();
    const { getUserAccessLevelOptions } = useUserAccessLevels();

    return (
        <Autocomplete
            data-testid="user-access-level-dropdown"
            fullWidth
            disableClearable={disableClearable}
            size={DROPDOWN_SIZES.Medium}
            labelLeft={t("Table##access level")}
            textFieldParams={{
                placeholder: t("Dialog##select")
            }}
            options={getUserAccessLevelOptions()}
            getOptionLabel={option => option.name}
            readOnly={isLoading}
            isOptionEqualToValue={(option, value) => option.name === value.name}
            onChange={(_, level) => onChange(level)}
            value={accessLevel}
            customStyle={{ marginBottom: "16px" }}
        />
    );
};

export { AccessLevel };
